import { styled } from '@mui/material';
import ContentLoader from 'react-content-loader';


export const StyledCategoryPageSkeleton = styled(ContentLoader)`
    width: 22rem;
    height:  22rem;
    ${(props) => props.theme.breakpoints.down("md")}{
      width: 14rem;
      height:22rem;  
    }
    ${(props) => props.theme.breakpoints.down("sm")}{
      width: 10rem;
      height:  20rem;
    }
  `;
